export default {
  computed: {
    availableTagOptions() {
      const selectedExtraTagsLower = this.selectedExtraTags.map(tag => `${tag}`.toLowerCase());
      return this.tags.filter(tag => !selectedExtraTagsLower.includes(`${tag}`.toLowerCase()));
    },

    selectedTypeLabel() {
      return this.typeOptions.find(option => option.value === this.selectedType)?.label || 'Type';
    },

    selectedStyleLabel() {
      return this.styleOptions.find(option => option.value === this.selectedStyle)?.label || 'Style';
    },
  },

  watch: {
    thumbnailWidth(value) {
      if (!value || value < 1) {
        this.thumbnailWidth = 1;
        return;
      }

      if (value > this.maxThumbnailWidth) {
        this.thumbnailWidth = this.maxThumbnailWidth;
      }
    },

    thumbnailHeight(value) {
      if (!value || value < 1) {
        this.thumbnailHeight = 1;
        return;
      }

      if (value > this.maxThumbnailHeight) {
        this.thumbnailHeight = this.maxThumbnailHeight;
      }
    },
  },

  methods: {
    addExtraTag(tagName) {
      const normalizedTag = `${tagName}`.trim();
      if (!normalizedTag) {
        return;
      }

      const hasTagInList = this.tags.some(tag => `${tag}`.toLowerCase() === normalizedTag.toLowerCase());
      if (!hasTagInList) {
        this.tags.unshift(normalizedTag);
      }

      const alreadySelected = this.selectedExtraTags.some(tag => `${tag}`.toLowerCase() === normalizedTag.toLowerCase());
      if (!alreadySelected) {
        this.selectedExtraTags.push(normalizedTag);
      }

      this.customTagInput = '';
    },

    removeExtraTag(tagName) {
      this.selectedExtraTags = this.selectedExtraTags.filter(tag => tag !== tagName);
    },

    getTemplateImageUrl() {
      return this.template?.image_url
        ? `/share?file=${this.template.image_url}&lightweight`
        : '';
    },

    clearPreviewObjectUrl() {
      if (this.previewObjectUrl) {
        URL.revokeObjectURL(this.previewObjectUrl);
        this.previewObjectUrl = null;
      }
    },

    showImageTools({ upload = false } = {}) {
      this.isImageToolsVisible = true;
      if (upload) {
        this.showUploadSection = true;
      }
    },

    updateThumbnailLimits() {
      const canvas = this.template?.preview?.canvas || this.template?.canvas;
      if (!canvas) {
        return;
      }

      const htmlCanvas = canvas.toCanvasElement ? canvas.toCanvasElement() : canvas;
      this.maxThumbnailWidth = htmlCanvas.width;
      this.maxThumbnailHeight = htmlCanvas.height;

      if (this.thumbnailWidth > this.maxThumbnailWidth) {
        this.thumbnailWidth = this.maxThumbnailWidth;
      }

      if (this.thumbnailHeight > this.maxThumbnailHeight) {
        this.thumbnailHeight = this.maxThumbnailHeight;
      }
    },

    handleImageChange(file) {
      this.clearPreviewObjectUrl();

      if (!file) {
        this.image = null;
        this.templateImagePreview = this.getTemplateImageUrl();
        return;
      }

      this.setImagePreview(file);
    },
  },
};

